import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"

const Page = ({ data }) => (
  <Layout>
    <SEO title="Text" />
    <div dangerouslySetInnerHTML={{ __html: data.wordpressPage.content }}></div>
  </Layout>
)

export const query = graphql`
  query {
    wordpressPage(id: { eq: "a0fc3cfd-a4a7-5b35-a6ba-3c439e926815" }) {
      content
    }
  }
`

export default Page
